import { Checkbox, Grid, TextField } from '@atgfr8/atg-ui-tailwind';
import { appointmentSchedulingStatusOptions } from '@common/stops/constants';
import { SelectInputCustom } from '@components/Select/SelectInputCustom';

type StopAppointmentSchedulingFieldsProps = {
  status: string;
  aiSchedulingEnabled: boolean;
  preference: string;
  statusError?: string;
  preferenceError?: string;
  onStatusChange: (status: string) => void;
  onAiSchedulingChange: (enabled: boolean) => void;
  onPreferenceChange: (preference: string) => void;
  testIdPrefix: string;
};

export const StopAppointmentSchedulingFields = (
  props: StopAppointmentSchedulingFieldsProps,
) => (
  <Grid container spacing={2} rowSpacing={2}>
    <Grid item size={{ xs: 12, sm: 6 }}>
      <SelectInputCustom
        label="Appointment Status"
        menuItems={appointmentSchedulingStatusOptions}
        value={props.status}
        placeholder="Select status"
        error={props.statusError}
        onChange={props.onStatusChange}
        dataTestId={`${props.testIdPrefix}-status`}
      />
    </Grid>
    <Grid item size={{ xs: 12, sm: 6 }}>
      <div class="flex min-h-10 items-center">
        <Checkbox
          label="AI Schedule"
          checked={props.aiSchedulingEnabled}
          onChange={props.onAiSchedulingChange}
          dataTestId={`${props.testIdPrefix}-ai-schedule`}
        />
      </div>
    </Grid>
    <Grid item size={12}>
      <TextField
        label="Appointment Preference"
        placeholder="Optional scheduling preference"
        value={props.preference}
        error={props.preferenceError}
        onChange={props.onPreferenceChange}
        maxLength={500}
        dataTestId={`${props.testIdPrefix}-preference`}
      />
    </Grid>
  </Grid>
);
